<script>

import { Carousel, Navigation, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

export default {
    name       : "CreateAccount",
    components : { Carousel, Slide, Navigation },
}

</script>

<script setup>

import { useMainStore } from "../stores/main";
import { storeToRefs }      from "pinia";
import {computed, nextTick} from "vue";

let emits = defineEmits( [ 'created' ] );

let store = useMainStore();
const {
          lang,
          copydeck,
          creatingUser,
          accounts,
          currentUserIndex,
          profileImages,
          profileModalMode,
          profileModalOpen,
      }   = storeToRefs( store );

let { setCurrentUserIndex } = store;

const sliderSettings = {
    itemsToShow : 4,
    snapAlign   : 'center',
    wrapAround  : true,
};


function onChangeImage ( index )
{
    creatingUser.value.image       = profileImages.value[ index.currentSlideIndex ];
    creatingUser.value.imageSquare = profileImages.value[ index.currentSlideIndex ].replace( '.png', '-small.png' );
}

creatingUser.value.image       = profileImages.value[ 0 ];
creatingUser.value.imageSquare = profileImages.value[ 0 ].replace( '.png', '-small.png' );


function saveProfile ()
{
    let newIndex = accounts.value.length;

    setCurrentUserIndex( newIndex );

    accounts.value.push( creatingUser.value );

    profileModalMode.value = 'select-account';
    profileModalOpen.value = false;

    //nextTick ( ()  =>  emits( "created" ));

    emits("created");
}

let avatarInUse = computed ( () => accounts.value.map ( a => a.image) );
function cssAvatarUse (image)
{
    let strClass = avatarInUse.value.includes(image) ? "disabled" : "";

    return strClass;
}

function inUsed (image)
{
    return avatarInUse.value.includes(image);
}

function avatarName (image)
{
    let account = accounts.value.find ( a => a.image === image );

    return account.name;
}
</script>

<template>
    <div class="page-box create-account">
        <button class="btn-primary btn-back" v-if="accounts.length > 0" @click=" profileModalMode = 'select-account' ">
            <svg class="icon" width="49" height="39" viewBox="0 0 49 39">
                <path
                    d="M46.7618 10.905C48.1568 11.235 49.2218 13.0725 48.6518 17.655C48.0818 22.2375 48.6893 26.085 48.2843 27.5175C47.8718 28.95 47.4818 30.24 39.0893 28.4025C30.6968 26.565 24.1193 24.69 24.1193 24.69C24.1193 24.69 26.4518 34.815 26.0393 37.065C25.6268 39.315 24.0668 40.35 16.6943 35.85C9.32933 31.35 -1.47067 20.565 0.16433 17.7C2.41433 13.7475 6.87682 10.095 17.2643 2.64751C22.1768 -0.877494 26.2268 -1.30499 25.6118 4.0125C24.9968 9.33 24.1268 13.59 24.1268 13.59C24.1268 13.59 42.3443 9.8625 46.7543 10.9125L46.7618 10.905Z"
                    fill="currentColor"></path>
            </svg>
            {{
                copydeck?.profile?.btnReturnToAccountSelection?.[ lang ] ?? 'copydeck.profile.btnReturnToAccountSelection'
            }}
        </button>
        <h1 class="page-box-title">{{ copydeck.profile.title_profile[lang] }}</h1>

        <div class="box-content">

            <Carousel
                v-bind="sliderSettings"
                @slide-end="onChangeImage">
                <Slide v-for="(image, i) in profileImages" :key="i">
                    <div class="card" :class="cssAvatarUse(image)">
                        <h2 class="card-title" v-if="!inUsed(image)">{{ copydeck.profile.label_profile_image[lang] }}</h2>
                        <h2 class="card-title" v-else>{{ avatarName(image) }}</h2>
                        <div class="card-thumbnail">
                            <img :src="`/images/accounts/${image}`" width="250" alt=""/>
                        </div>
                        <div class="card-name" v-if="!inUsed(image)">
                            <input type="text" :placeholder="copydeck.profile.label_profile_name[lang]" v-model="creatingUser.name"/>
                        </div>
                        <div class="card-button" v-if="!inUsed(image)">
                            <button class="btn-primary btn-choose" :disabled="creatingUser.name.length < 1"
                                    @click="saveProfile">{{ copydeck.profile.btn_save[lang] }}
                            </button>
                        </div>
                    </div>
                </Slide>

                <template #addons>
                    <div class="carousel-nav">
                        <h2 class="subtitle">{{ copydeck.profile.label_create_profile[lang] }}</h2>
                        <navigation>
                            <template #next>
                                <svg width="49" height="39" viewBox="0 0 49 39">
                                    <path
                                        d="M2.04484 10.905C0.649836 11.235 -0.415163 13.0725 0.154837 17.655C0.724836 22.2375 0.117337 26.085 0.522337 27.5175C0.934836 28.95 1.32484 30.24 9.71733 28.4025C18.1098 26.565 24.6873 24.69 24.6873 24.69C24.6873 24.69 22.3548 34.815 22.7673 37.065C23.1798 39.315 24.7398 40.35 32.1123 35.85C39.4773 31.35 50.2773 20.565 48.6423 17.7C46.3923 13.7475 41.9298 10.095 31.5423 2.64751C26.6298 -0.877494 22.5798 -1.30499 23.1948 4.0125C23.8098 9.33 24.6798 13.59 24.6798 13.59C24.6798 13.59 6.46233 9.8625 2.05234 10.9125L2.04484 10.905Z"
                                        fill="currentColor"/>
                                </svg>
                                <span class="sr-only">{{ copydeck.profile.btn_next[lang] }}</span>
                            </template>
                            <template #prev>
                                <svg width="49" height="39" viewBox="0 0 49 39">
                                    <path
                                        d="M46.7618 10.905C48.1568 11.235 49.2218 13.0725 48.6518 17.655C48.0818 22.2375 48.6893 26.085 48.2843 27.5175C47.8718 28.95 47.4818 30.24 39.0893 28.4025C30.6968 26.565 24.1193 24.69 24.1193 24.69C24.1193 24.69 26.4518 34.815 26.0393 37.065C25.6268 39.315 24.0668 40.35 16.6943 35.85C9.32933 31.35 -1.47067 20.565 0.16433 17.7C2.41433 13.7475 6.87682 10.095 17.2643 2.64751C22.1768 -0.877494 26.2268 -1.30499 25.6118 4.0125C24.9968 9.33 24.1268 13.59 24.1268 13.59C24.1268 13.59 42.3443 9.8625 46.7543 10.9125L46.7618 10.905Z"
                                        fill="currentColor"/>
                                </svg>
                                <span class="sr-only">{{ copydeck.profile.btn_previous[lang] }}</span>
                            </template>
                        </navigation>
                    </div>
                </template>
            </Carousel>

        </div>
    </div>
</template>

<style scoped>

</style>
